import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from 'react';
import axios from 'axios';
import { DataContext } from '../context/DataProvider';
const PermissionList = (searchText: string, pageNumber: number) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [ListPermiision, setListPermiision] = useState([]);
  const [hasMore, setHaseMore] = useState(false);
  const { tokenLogin }: any = useContext(DataContext);
  useEffect(() => {
    // console.log(hasMore)
    setLoading(true);
    setError(false);
    let cancel: any;
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BASE_URL}/api/Permission/PermissionList`,

      headers: {
        Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
        // Authorization: `Bearer ${CookieToken.accessToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        filters: {
          pageNumber: pageNumber,
          pageSize: 30,
          isSortAscending: true,
          sortField: '',
          search: searchText,
        },
        id: 0,
        projectName: '',
        claimType: '',
        claimValue: '',
        description: '',
        isActive: null,
      }),

      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        console.log('res', res);
        setListPermiision((ListPermiision) => {
          return new Set([
            ...ListPermiision,
            ...res.data.data.items.map((i) => {
              return { label: i.claimValue + " "+ i.projectName, value: i.id };
            }),
          ]);
        });
        // console.log(Array.from(res.data).length>1 ?true:false)

        if (Array.from(res.data.data.items).length > 1) {
          setHaseMore(true);
        } else {
          setHaseMore(false);
        }

        setLoading(false);
        console.log('Ccc', res.data.data.items);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return setError(e);
      });
    return () => cancel();
  }, [searchText, pageNumber]);
  useEffect(() => {
    setListPermiision([]);
  }, [searchText]);
  return { loading, error, ListPermiision, hasMore };
};

export default PermissionList;
